import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IResultadoDocument, IElasticReturnClass, Expedientes, ElasticExpedientesByKeyword } from '../../../core/model/inventories';
import { InventariosService } from '../../../core/services/inventarios.service';

@Component({
  selector: 'app-inventory-navigator',
  templateUrl: './inventory-navigator.component.html',
  styleUrls: ['./inventory-navigator.component.css']
})
export class InventoryNavigatorComponent implements OnInit {



  unidadesDocumentales: IResultadoDocument<IElasticReturnClass>[] = [];
  @Input() set unidades(unidadesDoc: IResultadoDocument<IElasticReturnClass>[]) {
    if (unidadesDoc ) {
      const hasToReload = this.unidadesDocumentales.length === 0 && this.unidadDocumentalSelected;
      this.unidadesDocumentales = unidadesDoc;
      if (hasToReload) {
        this.loadNavigator();
       }
    }
   }
  unidadDocumentalSelected: IResultadoDocument<IElasticReturnClass>;
  @Input() set unidadDocumental(unidadDoc: IResultadoDocument<IElasticReturnClass>) {
    if (unidadDoc) {
      this.unidadDocumentalSelected = unidadDoc;
      if (this.unidadesDocumentales.length !== 0) {
        this.loadNavigator();
       }
    }
  }
  @Input() keyword: ElasticExpedientesByKeyword;

  @Output() navigateNewUnidadDocumental = new EventEmitter<boolean>();

  existUnidadDocumental = false;
  numeroUnidadDocumental = 0;
  moveBefore = false;
  moveNext = false;
  constructor(private inventoryService: InventariosService) { }

  ngOnInit() {
  }

  private loadNavigator() {
    const unidadDocumentalIndex = this.unidadesDocumentales.indexOf(this.unidadDocumentalSelected);
    if (unidadDocumentalIndex > -1) {
      this.existUnidadDocumental = true;
      this.numeroUnidadDocumental = unidadDocumentalIndex + 1;
      this.moveBefore = unidadDocumentalIndex != 0;
      this.moveNext = this.numeroUnidadDocumental < this.unidadesDocumentales.length;
    } else {
      this.existUnidadDocumental = false;
     }
   }

  goToBefore() {
    const index = this.numeroUnidadDocumental > 1 ? this.numeroUnidadDocumental - 2 : 0;
    this.navigateUnidadDocumental(this.unidadesDocumentales[index]);
  }

  goToNext() {
    this.navigateUnidadDocumental(this.unidadesDocumentales[this.numeroUnidadDocumental]);
  }


  private navigateUnidadDocumental(element: IResultadoDocument<IElasticReturnClass>) {
    this.existUnidadDocumental = false;
    const newExpediente = element as IResultadoDocument<Expedientes>;
    const unidades = this.unidadesDocumentales as IResultadoDocument<Expedientes>[];
    this.inventoryService.goToRecordDetail(newExpediente, this.keyword, unidades);
    this.navigateNewUnidadDocumental.emit(true);
  }

}
